<template>
    <div class="content">
        <div class="breadCrumb">
            <n-breadcrumb separator=">">
                <n-breadcrumb-item @click="$router.push({path: `/helpcenter/${route.params.hashcode}`})">Help-Center</n-breadcrumb-item>
                <n-breadcrumb-item @click="$router.go(-1)">View My Order</n-breadcrumb-item>
                <n-breadcrumb-item>Contact Customer</n-breadcrumb-item>
            </n-breadcrumb>
        </div>

        <div class="order-details">
            <div>
                <h2 style="display:inline">Contact Customer Care</h2>
            </div>
        </div>

        <div v-if="isItemSelected === false">
            <h3>Please select the item you are contacting us about</h3>
            <div>
                <n-list bordered>
                    <n-list-item>
                    <template #prefix>
                        <n-radio
                            :checked="selectedItem === '360156'"
                            @change="changeHandler"
                            value="360156"
                            name="item"
                        > </n-radio>
                    </template>
                                360156: VOGUE FREESTANDING OVEN 60CM 70L HOTPLATES WHITE<br />
                                Sold By Trade depot<br />
                                Ordered on 16 May 2021<br /> 
                        
                    </n-list-item>
                    <n-list-item>
                    <template #prefix>
                        <n-radio
                            :checked="selectedItem === '310100'"
                            @change="changeHandler"
                            value="310100"
                            name="item"
                        > </n-radio>
                    </template> 
                            310100: VOGUE FREESTANDING OVEN 60CM 70L HOTPLATES WHITE<br />
                            Sold By Trade Depot<br />
                            Ordered on 16 May 2021<br /> 
                    </n-list-item>
                </n-list>
                <n-button type="info" @click="checkItemSelectedHandler">COUNTINUE</n-button>
            </div>
        </div>
        <div v-if="isItemSelected === true">
            <h3>Your request will be sent to Trade Depot</h3>
            <n-card style="background-color: #EEEEEE">
                310100: VOGUE FREESTANDING OVEN 60CM 70L HOTPLATES WHITE<br />
                Sold By Trade Depot<br />
                Ordered on 16 May 2021<br /> 
            </n-card>
            <div v-if="isArriveSelectd === false">
                <h3>Tell us more about you issue</h3>
                <n-list bordered>
                    <n-list-item>
                        <template #prefix>
                            <n-radio :checked="isItemArrived === 'arrived'" @change="itemArrivedBtnChangeHandler" value="arrived" name="checkItemArrived">
                                Before Your Item Arrives (Ordering and Delivery)
                            </n-radio>
                        </template>
                    </n-list-item>
                    <n-list-item>
                        <template #prefix>
                            <n-radio :checked="isItemArrived === 'notArrive'" @change="itemArrivedBtnChangeHandler" value="notArrive" name="checkItemArrived" >
                                After Your Item Arrives (Invoices, Warranty &amp; Product Support)
                            </n-radio>
                        </template> 
                    </n-list-item>
                </n-list>
                <n-button type="info" @click="checkArriveSelectedHandler">COUNTINUE</n-button>
            </div>
            <div v-if="isArriveSelectd === true">
                <h3>Please specify issue details</h3>
                <n-list bordered>
                    <n-list-item>
                        <template #prefix>
                            <n-radio :checked="issue === 'cancel order'" @change="issueChangeHandler" value="cancel order" name="issue">
                                I want to cancel my order 
                            </n-radio>
                        </template>
                    </n-list-item>
                    <n-list-item>
                        <template #prefix>
                            <n-radio :checked="issue === 'not send'" @change="issueChangeHandler" value="not send" name="issue" >
                                My order has not been sent
                            </n-radio>
                        </template> 
                    </n-list-item>
                    <n-list-item>
                        <template #prefix>
                            <n-radio :checked="issue === 'not receive'" @change="issueChangeHandler" value="not receive" name="issue" >
                                My order was sent but I have not received it yet
                            </n-radio>
                        </template> 
                    </n-list-item>
                </n-list>
                <n-button type="info">Submit Question</n-button>
            </div>
        </div>
    </div>

</template>

<script>
import { useRoute } from 'vue-router'
import { NBreadcrumb, NBreadcrumbItem, NList, NListItem, NRadio, NButton, NCard} from "naive-ui";
import { reactive, toRefs} from "vue";

export default{
    name: "ContactCustomer",
    components:{
        NBreadcrumb,
        NBreadcrumbItem,
        NList,
        NListItem,
        NRadio,
        NButton,
        NCard
    },
    setup(){
        const route = useRoute()

        // let selectedItem = ref(null) 
        // let isItemSelected = ref(false)
        // let isItemArrived = ref(null)
        // let isArriveSelectd = ref(false)
        // let issue = ref(null)

        const state = reactive({
            selectedItem:null,
            isItemSelected:false,
            isItemArrived:null,
            isArriveSelectd:false,
            issue:null
        })

        //select a item at first step
        const changeHandler = (e) =>{
            // selectedItem.value = e.target.value
            // console.log(selectedItem.value,"selectedItem.value in changeHandler")
            state.selectedItem = e.target.value
            console.log(state.selectedItem, state, "state.selectedItem in changeHandler")
        }

        //check the item if it is selected then go next step
        const checkItemSelectedHandler = () =>{
            // if(selectedItem.value !== null){
            //     isItemSelected = true
            // }
            if(state.selectedItem !== null){
                state.isItemSelected = true
            }
        }

        const itemArrivedBtnChangeHandler = (e) =>{
            // isItemArrived.value = e.target.value
            // console.log(isItemArrived.value,"isItemArrived.value in itemArrivedBtnChangeHandler")
            state.isItemArrived = e.target.value
            console.log(state.isItemArrived, state, "state.isItemArrived in itemArrivedBtnChangeHandler")
        }

        const checkArriveSelectedHandler = () =>{
            // if(isItemArrived.value !== null){
            //     isArriveSelectd.value = true
            // }
            if(state.isItemArrived !== null){
                state.isArriveSelectd = true
            }
        }

        const issueChangeHandler = (e) => {
            // issue.value = e.target.value
            // console.log(issue.value,"issue.value in issueChangeHandler")
            state.issue = e.target.value
            console.log(state.issue, state, "state.issue in issueChangeHandler")
        }

        return{
            route,
            // selectedItem,
            // isItemSelected,
            // isItemArrived,
            // isArriveSelectd,
            // issue,
            ...toRefs(state),
            changeHandler,
            checkItemSelectedHandler,
            itemArrivedBtnChangeHandler,
            checkArriveSelectedHandler,
            issueChangeHandler
        }
    }
}
</script>

<style scoped>
.order-details{
    display: flex;
    flex-wrap: wrap;
    margin: 25px 0;
}

.breadCrumb{
    padding-top: 20px;
    margin-bottom: 10px;
}
</style>